import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { BasicReturn } from '../../../core/types/common/api-response'
import { GetCommercialPartnersDataResponse } from '../../../core/types/dto/partner/get-commercial-partner-data'
import { UpdatePartnerDataParams } from '../../../core/types/dto/partner/update-partner-data'
import { HttpClientOptionsService } from '../../authentication/services/http-client-options.service'
import { GetComercialPartnerList, GetPartnerInformationResponse } from '../types/partners/partner-types'

@Injectable({ providedIn: 'root' })
export class PartnersDataService {
    constructor(
        private httpClient: HttpClient,
        private httpClientOptions: HttpClientOptionsService,
    ) {}

    getCommercialPartnersData(body: any) {
        return this.httpClient.post<GetCommercialPartnersDataResponse>(
            `${environment.URL_BASE}/partnerhub/commercial-partner/get-commercial-partners-data`,
            body,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    updateBadge(queryParams: any) {
        return this.httpClient.get<any>(
            `${environment.URL_BASE}/partnerhub/perks/update-badge`,
            this.httpClientOptions.getPartnerhubAuthorizationAndParams(queryParams),
        )
    }

    updateState(body: any) {
        return this.httpClient.post<any>(
            `${environment.URL_BASE}/partnerhub/commercial-partner/update-state`,
            body,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    updateApplication(body: any) {
        return this.httpClient.post<any>(
            `${environment.URL_BASE}/partnerhub/commercial-partner/update-application`,
            body,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    getAllActivesBusinessDevelopers() {
        return this.httpClient.get<any>(
            `${environment.URL_BASE}/partnerhub/business-developers/get-all-active-business-developers`,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    updateCommercialPartnerResponsible(commercialPartnerAndNewResponsibleBusinessDeveloperIds: any) {
        return this.httpClient.post<any>(
            `${environment.URL_BASE}/partnerhub/commercial-partner/update-commercial-partner-responsible`,
            commercialPartnerAndNewResponsibleBusinessDeveloperIds,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    getCommercialPartnerHistory(commercialPartnerId: any) {
        return this.httpClient.get<any>(
            `${environment.URL_BASE}/partnerhub/commercial-partner/get-commercial-partner-history/${commercialPartnerId}`,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    getPartnersList() {
        return this.httpClient.get<any>(
            `${environment.URL_BASE}/partnerhub/partners/get-all-partners-list`,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    updateCommercialPartnerSalesPartnerId(idsToUpdateSalesPartnerOfCommercialPartner: any) {
        return this.httpClient.put<any>(
            `${environment.URL_BASE}/partnerhub/commercial-partner/update-commercial-partner-sales-partner-id`,
            idsToUpdateSalesPartnerOfCommercialPartner,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    getHubPartnersList() {
        const url = `${environment.URL_BASE}/partnerhub/commercial-partner/get-commercial-partners-list`
        const options = this.httpClientOptions.getPartnerhubAuthorization()
        return this.httpClient.get<GetComercialPartnerList>(url, options)
    }

    getAllSalesList() {
        const url = `${environment.URL_BASE}/partnerhub/sales-team-members/get-all-sales-team-members-list`
        const options = this.httpClientOptions.getPartnerhubAuthorization()
        return this.httpClient.get<any>(url, options)
    }

    requestBadgedPartnersReport() {
        return this.httpClient.get<any>(
            `${environment.URL_BASE}/partnerhub/perks/request-badged-partners-report`,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    requestPartnersIdsReport() {
        return this.httpClient.get<any>(
            `${environment.URL_BASE}/partnerhub/commercial-partner/request-partner-ids-report`,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    changePartnerSetupModel(body: any) {
        return this.httpClient.put<any>(
            `${environment.URL_BASE}/partnerhub/commercial-partner/change-partner-setup-model`,
            body,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    getPartnerInformation(hubPartnerId: string) {
        return this.httpClient.get<GetPartnerInformationResponse>(
            `${environment.URL_BASE}/partnerhub/commercial-partner/get-partner-information/${hubPartnerId}`,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }

    updatePartnerData(body: UpdatePartnerDataParams) {
        return this.httpClient.post<BasicReturn>(
            `${environment.URL_BASE}/partnerhub/commercial-partner/update-parnter-data`,
            body,
            this.httpClientOptions.getPartnerhubAuthorization(),
        )
    }
}
